import React from 'react';
import Helmet from 'react-helmet';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import MentionMeWidget from '../components/Widgets/MentionMeWidget';

import '../../static/scss/pages/referFriend.scss';

type Props = {
  firstName: string,
  lastName: string,
  email: string
};

const ReferFriend = ({ firstName, lastName, email }: Props) => (
  <>
    <Helmet
      title="JustPark - The Parking App | Refer a Friend"
      titleTemplate="%s"
    />
    <div className="p-refer-friend">
      <MentionMeWidget
        situation="landingpage"
        firstName={firstName}
        lastName={lastName}
        email={email}
      />
    </div>
  </>
);

const mapStateToProps = state => ({
  firstName: state.auth.user ? state.auth.user.firstName : '',
  lastName: state.auth.user ? state.auth.user.lastName : '',
  email: state.auth.user ? state.auth.user.email : ''
});

export default hot(module)(
  compose(
    connect(
      mapStateToProps,
      {}
    )
  )(ReferFriend)
);
